import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useLocation, useParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Build = lazy(() => import('./components/pages/Build').then(({Build}) => ({default: Build})))
const Preview = lazy(() =>
  import('./components/pages/Preview').then(({Preview}) => ({default: Preview})),
)
const Settings = lazy(() =>
  import('./components/pages/Settings').then(({Settings}) => ({default: Settings})),
)

export function BuildPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Build'))

  return (
    <Suspense>
      <Build activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

export function SettingsPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Settings'))

  return (
    <Suspense>
      <Settings activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

export function PreviewPage() {
  const {activeAssignmentId} = useParams()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  useDocumentTitle(t('Preview'))

  return (
    <Suspense>
      <Preview
        activeAssignmentId={activeAssignmentId}
        printOnLoad={searchParams.get('printOnLoad') === '1'}
      />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the building module.
 */
export const buildRoutes = [
  {
    index: true,
    element: <BuildPage />,
  },
  {
    path: 'settings',
    element: <SettingsPage />,
  },
  {
    path: 'preview',
    element: <PreviewPage />,
  },
]
